import styled from "@emotion/styled";
import { Body6RegularTypography } from "../../primitives/Typography/typographyVariants";

export const StyledIcon = styled.i<{ iconColor?: string }>`
  font-size: 10px;
  font-style: normal;
  font-weight: 900 !important;
  line-height: 18px; /* 180% */
  letter-spacing: 0.2px;
  text-align: center;
  color: ${(props) => props.iconColor || "inherit"};
`;

export const TagLabel = styled(Body6RegularTypography)`
  font-family: Rubik;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 10px */
  letter-spacing: 0.2px;
`;
